import { BLAdmin } from '@/types/profile.types';
import { Put } from '../helpers';

const UpdateUserChannelSettings = (blAdminID: number, channel: number, permissions: string[]): Promise<BLAdmin> => {
  return Put({
    url: `/v3/admin/auth/update-user-channel-settings`,
    body: { blAdminID, channel, permissions, ssoLogin: false },
  });
};

export default UpdateUserChannelSettings;
